Jelly.Handlers.Document_Mouse_Move = function(event)
{
	// Call handlers functions for document level mouse movement.

	// Hide jelly reference highlights
	Jelly.Interface.Hide_Highlights();
};